export const columns = [
  "User Name",
  "First Name",
  "Last Name",
  "Email",
  "Approval",
];
